/**
 * Build environment and auth redirect helpers.
 */

export type Environment = 'development' | 'staging' | 'production';

export function getEnvironment(): Environment {
  const env =
    typeof import.meta.env.VITE_APP_ENV === 'string' ? import.meta.env.VITE_APP_ENV : 'development';
  if (env === 'development' || env === 'staging' || env === 'production') {
    return env;
  }
  throw new Error('Invalid VITE_APP_ENV');
}

/**
 * Web-side auth redirect URL (current origin's `/auth/callback`).
 */
export function getWebAuthRedirectUrl(): string {
  return `${globalThis.location.origin}/auth/callback`;
}
